import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Modal.css";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useTranslation } from "react-i18next";

const ModalComponent = ({
  id = "",
  className = "",
  size = "xl",
  isOpen = false,
  fade = true,
  scrollable = false,
  centered = true,
  onClose = () => { },
  children,
  title = null,
  showSubmitButton = false,
  showCloseButton = false,
  showCancelButton = false,
  onSubmit,
  closeButtonDisabled = false,
  submitButtonDisabled = false,
  cancleButtonDisabled = false,
  hideHeader = false,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(isOpen);

  const handleOnClose = () => {
    setOpen(false);
    onClose && onClose();
  };

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  return (
    <>
      <Modal
        isOpen={open}
        toggle={handleOnClose}
        id={id}
        fade={fade}
        scrollable={scrollable}
        centered={centered}
        size={size}
        backdrop={"static"}
        className={cn({ [styles["modal"]]: true, [className]: true })}
      >
        {title && !hideHeader && (
          <ModalHeader toggle={handleOnClose} style={{ overflow: 'auto' }}>
            {title}
          </ModalHeader>
        )}
        {!title && !hideHeader && (
          <div className={cn({ [styles["box-btn-close"]]: true })}>
            <div
              className="btn-close"
              id="modelClose"
              onClick={handleOnClose}
            ></div>
          </div>
        )}
        <ModalBody>{children}</ModalBody>
        {(showCloseButton || showSubmitButton || showCancelButton) && (
          <ModalFooter>
            {showCancelButton && (
              <Button
                color="primary"
                onClick={handleOnClose}
                disabled={cancleButtonDisabled}
              >
                {t("cancel")}
              </Button>
            )}
            &nbsp;
            {showSubmitButton && (
              <Button
                color="primary"
                onClick={onSubmit}
                disabled={submitButtonDisabled}
              >
                {t("confirm")}
              </Button>
            )}
            {showCloseButton && (
              <Button
                outline
                color="primary"
                onClick={handleOnClose}
                disabled={closeButtonDisabled}
              >
                {t("close")}
              </Button>
            )}
          </ModalFooter>
        )}
      </Modal>
    </>
  );
};

export default ModalComponent;
